@import '~style-sheet-helpers/core.less';

.BYOL-warning {
  margin-bottom: 8px;
}
